import { HeaderSeparator, ReportDatePicker, ReportHeader, ReportHeaderDates, ReportHeaderMobileActions, RunButton } from '@/components/reports/header'

export default function ReportsAllocationHeader({ onChangeDates, dates, sync, isLoading }) {
  return <>
    <ReportHeader title='URL Anomalies Report'>
      <ReportHeaderDates>
        <ReportDatePicker dates={dates} onChange={onChangeDates} />
      </ReportHeaderDates>
      <HeaderSeparator />
      <ReportHeaderMobileActions>
        <RunButton onClick={sync} isLoading={isLoading} disabled={isLoading} />
      </ReportHeaderMobileActions>
    </ReportHeader>
  </>
}
